import { useEffect, useState } from "react"

export const MOBILE_LAYOUT_QUERY = "(max-width: 767.98px)"

export const isMobileLayoutViewport = () => (
  typeof window !== "undefined" && window.matchMedia(MOBILE_LAYOUT_QUERY).matches
)

export default function useMobileLayout() {
  const [isMobileLayout, setIsMobileLayout] = useState(isMobileLayoutViewport)

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_LAYOUT_QUERY)
    const onChange = () => setIsMobileLayout(mediaQuery.matches)

    onChange()
    mediaQuery.addEventListener("change", onChange)
    return () => mediaQuery.removeEventListener("change", onChange)
  }, [])

  return isMobileLayout
}
